import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useLocale } from '../../i18n/locale-context.js';
export function AggregationElectionExecutingStep() {
    const { t } = useLocale();
    return (_jsxs("section", { "aria-labelledby": "executing-heading", "aria-busy": "true", children: [_jsx("h3", { id: "executing-heading", children: t('aggregation.executing.heading') }), _jsx("p", { role: "status", children: t('aggregation.executing.status') })] }));
}
//# sourceMappingURL=election-executing-step.js.map